import React from "react"

import { PhraseLabel, Marker, IconItem } from "ui"
import S from "./ContactDetails.styled"

const ContactDetails = ({ contact, address }) => (
  <S.Wrapper id="contactDetails">
    <PhraseLabel>{address?.label}</PhraseLabel>
    <S.AddressWrapper>
      <Marker />
      <S.Address>{address?.content}</S.Address>
    </S.AddressWrapper>
    <S.ContactInformation>
      <IconItem phone>{contact?.phone}</IconItem>
      <IconItem>{contact?.emailNo1}</IconItem>
      <IconItem>{contact?.emailNo2}</IconItem>
      <IconItem>{contact?.emailNo3}</IconItem>
      <IconItem>{contact?.emailNo4}</IconItem>
    </S.ContactInformation>
  </S.Wrapper>
)

export default ContactDetails
